import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const uploadImage = ({ onSuccess }) => {
  setTimeout(() => {
    onSuccess('ok');
  }, 0);
};

const beforeUpload = (file) => {
  const isLt5M = file.size / 1024 / 1024 < 20;

  if (!isLt5M) {
    message.error('Image must smaller than 20MB!');
  }

  return isLt5M;
};

const UploadImage = ({ setFileObject, defaultImage }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      // Get this url from response in real world.
      setFileObject(info.file.originFileObj);
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  return (
    <Upload
      multiple={false}
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      customRequest={uploadImage}
      beforeUpload={beforeUpload}
      onChange={handleChange}
    >
      {defaultImage || imageUrl ? (
        <img
          src={imageUrl ? imageUrl : defaultImage}
          alt="avatar"
          style={{
            width: '100%',
          }}
        />
      ) : (
        uploadButton
      )}
    </Upload>
  );
};

UploadImage.propTypes = {
  setFileObject: PropTypes.func,
  defaultImage: PropTypes.string,
};

export default UploadImage;
